<template>
    <div>
        <v-app>
            <v-card>
                <v-card-title>
                    Stores
                    <v-spacer></v-spacer>
                    <v-btn class @click="fetchData" text icon color="blue">
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-card class="d-flex ">
                        <v-text-field
                        v-model="search"
                        clearable
                        label="Búsqueda"
                        single-line
                        hide-details
                        outlined
                        class="ml-2 mr-2"
                        ></v-text-field>
                        <button @click="fetchData" :class="'btn btn-primary'">Buscar</button>
                    </v-card>
                </v-card-text>
                <v-card-text>
                    <v-data-table
                        :items="tableData"
                        :headers="headers"
                        no-results-text="No hay resultados disponibles"
                        no-data-text="No hay datos disponibles"
                        loading-text="Cargando datos..."
                        :search="search"
                    >
                        <template v-slot:item.logo_url="{ item }">
                            <td class="text-center">
                                <span v-if="item.logo_url">{{item.logo_url}}</span>
                                <span class="font-italic font-weight-thin" v-else>Sin asignar</span>
                            </td>
                        </template>
                        <template v-slot:item.storegroup="{ item }">
                            <td class="text-center">
                                <span v-if="item.store_group">{{item.store_group.name}}</span>
                                <span class="font-italic font-weight-thin" v-else>Sin asignar</span>
                            </td>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <td class="text-center">
                                <v-btn @click="openDialogEditStore(item)" color="blue" icon><v-icon>mdi-pencil</v-icon></v-btn>
                            </td>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-app>
        <dialog-edit-store @success="fetchData"></dialog-edit-store>
    </div>
</template>

<script>
import DialogEditStore from '@/views/oms/Admin/DialogEditStore';
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
export default {
    components:{
        DialogEditStore
    },
    data(){
        return{
            search: '',
            tableData: [],
            headers: [{text:'Nombre', value:'name'},{text:'Logo', value:'logo_url'},{text:'Grupo', value:'storegroup'},{text:'Acciones',value:'actions'}]
        }
    },
    mounted(){
        this.fetchData();
    },
    created(){
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Stores", route: "/admin/stores" },
        ]);
    },
    methods:{
        fetchData(){
            var vm = this;
            this.axios({
                url: 'admin/stores',
                method: 'GET'
            }).then( response => {
                vm.tableData = response.data;
            }).catch( error => {
                console.log(error);
            })
        },
        openDialogEditStore(item){
            this.$emit('openDialogEditStore', item);
        }
    }
}
</script>